import React, { useState, useEffect } from 'react';
import { fetchBusinessInfo, fetchCategoryName, fetchProductInfo } from '../bridge';
import Products from './Products';
import '../styles/Category.css'

const Category = ({ supabase, userEmail, uploaderId }) => {
  const [images, setImages] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [productInfo, setProductInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [businessCurrency, setBusinessCurrency] = useState('$');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const previousCategoryName = await fetchCategoryName({ userEmail, categoryId: uploaderId });
        if (previousCategoryName) setCategoryName(previousCategoryName);

        const previousBusinessInfo = await fetchBusinessInfo(userEmail);
        if (previousBusinessInfo) {
          setBusinessCurrency(previousBusinessInfo.business_currency || '$');
        }

        await fetchImages();
      } catch (error) {
        console.error('Error fetching category data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userEmail, uploaderId]);

  const fetchImages = async () => {
    if (!userEmail) {
      console.error('User email is missing.');
      return;
    }

    try {
      const { data, error } = await supabase.storage.from('images').list(`${userEmail}/${uploaderId}`);
      if (error) {
        console.error('Error fetching images:', error);
        return;
      }

      if (Array.isArray(data) && data.length > 0) {
        const imageData = data.map(file => ({
          id: file.name,
          url: supabase.storage.from('images').getPublicUrl(`${userEmail}/${uploaderId}/${file.name}`).data.publicUrl,
          name: file.name,
        }));

        setImages(imageData);
        await retrieveProductInfo(imageData);
      } else {
        setImages([]);
        setProductInfo([]);
        console.log('No files found in the specified folder.');
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  const retrieveProductInfo = async (imageData) => {
    try {
      const productInfoArray = await Promise.all(
        imageData.map(async (image) => {
          const productInfo = await fetchProductInfo({ userEmail, categoryId: uploaderId, imageIndex: image.id });
          return productInfo || { product_name: '', product_price: '', product_description: '' };
        })
      );

      setProductInfo(productInfoArray);
    } catch (error) {
      console.error('Error fetching product info:', error);
    }
  };

  if (loading || images.length === 0) {
    return null;
  }

  return (
    <div className='category-container'>
      <h2 className='category-name'>{categoryName}</h2>
      <div className='image-row'>
        {images.map((image, index) => (
          <Products key={index} image={image} index={index} productInfo={productInfo} currency={businessCurrency} />
        ))}
      </div>
    </div>
  );
};

export default Category;